const keysToCopy = ['currentUser', 'geotikRefreshToken', 'timeZone'];

/** Migrate legacy browser storage before NgRx reducers are constructed. */
export function migrateSessionStorage(storage: Storage, prefix: string): void {
  const keysWhiteList = ['mapbox', prefix];
  let storageKeys = getStorageKeys(storage);

  for (const key of keysToCopy) {
    if (!storageKeys.includes(key)) { continue; }
    const value = key === 'currentUser'
      ? retainMinimalCredential(storage.getItem(key))
      : storage.getItem(key);
    if (value !== null) {
      storage.setItem(`${prefix}.${key}`, value);
    }
    storage.removeItem(key);
  }

  storageKeys = getStorageKeys(storage);
  for (const storageKey of storageKeys) {
    if (storageKey === `${prefix}.currentUser`) {
      const minimal = retainMinimalCredential(storage.getItem(storageKey));
      if (minimal) { storage.setItem(storageKey, minimal); }
      else { storage.removeItem(storageKey); }
      continue;
    }

    const isLegacyCache = storageKey.startsWith('cached') || storageKey.startsWith(`${prefix}.cached`);
    const isRouteCache = storageKey.startsWith('tracks.routes') || storageKey.startsWith(`${prefix}.tracks.routes`);
    const isV2RouteCache = storageKey.startsWith('tracks.routes.v2.') ||
      storageKey.startsWith('tracks.routes.index.v2.') ||
      storageKey.startsWith(`${prefix}.tracks.routes.v2.`) ||
      storageKey.startsWith(`${prefix}.tracks.routes.index.v2.`);

    if (isLegacyCache || (isRouteCache && !isV2RouteCache)) {
      storage.removeItem(storageKey);
    } else if (keysWhiteList.every(key => storageKey.indexOf(key) === -1)) {
      storage.removeItem(storageKey);
    }
  }
}

function getStorageKeys(storage: Storage): string[] {
  return Array.from({ length: storage.length }, (_, index) => storage.key(index))
    .filter((key): key is string => key !== null);
}

function retainMinimalCredential(raw: string | null): string | null {
  if (!raw) { return null; }
  try {
    const credential = JSON.parse(raw);
    if (!credential?.accessToken) { return null; }
    return JSON.stringify({
      accessToken: credential.accessToken,
      expirationTokenDate: credential.expirationTokenDate,
      language: credential.language,
      ...(credential.username ? { username: credential.username } : {}),
    });
  } catch {
    return null;
  }
}
